import { observable } from 'mobx';

export const NOTIFICATION_TARGETS = ['partner_message_reply_required', 'partner_message_normal'] as const;
export type NotificationTarget = typeof NOTIFICATION_TARGETS[number];

export const NOTIFICATION_TARGET_LABELS: Record<NotificationTarget, string> = {
  partner_message_reply_required: 'チャットメッセージ：要返信',
  partner_message_normal: 'チャットメッセージ：要返信以外'
};

export const NOTIFICATION_CHANNELS = ['email', 'slack', 'app'] as const;
export type NotificationChannel = typeof NOTIFICATION_CHANNELS[number];

export const NOTIFICATION_CHANNEL_LABELS: Record<NotificationChannel, string> = {
  email: 'メール',
  slack: 'Slack',
  app: 'アプリ'
};

export type UserNotificationSettingResponseArgs = {
  target: NotificationTarget;
  channel: NotificationChannel;
  enabled: boolean;
};

export type UserNotificationSettingArgs = {
  target: NotificationTarget;
  channel: NotificationChannel;
  enabled: boolean;
};

export const convertUserNotificationSettingResponseToArgs = (
  response: UserNotificationSettingResponseArgs
): UserNotificationSettingArgs => ({
  target: response.target,
  channel: response.channel,
  enabled: response.enabled
});

export default class UserNotificationSetting {
  @observable target: NotificationTarget;
  @observable channel: NotificationChannel;
  @observable enabled: boolean;

  constructor(args: UserNotificationSettingArgs) {
    this.target = args.target;
    this.channel = args.channel;
    this.enabled = args.enabled;
  }
}
